

































































































import { Component, Vue } from 'vue-property-decorator';
import { DxScrollView } from 'devextreme-vue';
import { DxPopup } from 'devextreme-vue/popup';
import notificationService from '@/services/notificationService';
import {
    PlanningsClient,
    ProjectProgressionDto,
} from '@/data/web-api-client';

@Component({
    components: {
        DxPopup,
        DxScrollView
    },
})
export default class ProjectProgressionDialog extends Vue {
    public projectId = '';
    public show = false;
    public loading = false;
    public details: ProjectProgressionDto | null = null;

    private planningsClient = new PlanningsClient(undefined, this.$axios);

    declare currency: any;

    public async load() {
        this.loading = true;

        try {
            this.details = await this.planningsClient.getProjectProgression(this.projectId);
        } catch (err) {
            notificationService.showAxiosError(err);
        } finally {
            this.loading = false;
        }

        setTimeout(() => {
            const barChartClassName = '.bar-chart';
            const barChartInnerClassName = '.bar-chart-inner';
            const percentageClassName = '.percentage';

            const projectProgressLabourBarChart = $('#project-progress-labour-popup').find(barChartClassName);
            const projectProgressTotalBarChart = $('#project-progress-total-popup').find(barChartClassName);
            const customerPaidBarChart = $('#customer-paid-popup').find(barChartClassName);
            const customerInvoicingBarChart = $('#customer-invoicing-popup').find(barChartClassName);
            const subcontractorInvoicedBarchart = $('#subcontractor-invoiced-popup').find(barChartClassName);

            const projectProgressLabourBarChartPercentage = projectProgressLabourBarChart.find(percentageClassName);
            const projectProgressTotalBarChartPercentage = projectProgressTotalBarChart.find(percentageClassName);
            const customerPaidBarChartPercentage = customerPaidBarChart.find(percentageClassName);
            const customerInvoicingBarChartPercentage = customerInvoicingBarChart.find(percentageClassName);
            const subcontractorInvoicedBarChartPercentage = subcontractorInvoicedBarchart.find(percentageClassName);

            if (this.details?.executedLabourCostRate! >= 60) {
                projectProgressLabourBarChartPercentage.css('color', '#fff');
            }

            if (this.details?.executedCostRate! >= 60) {
                projectProgressTotalBarChartPercentage.css('color', '#fff');
            }

            if (this.details?.paidInvoiceRate! >= 60) {
                customerPaidBarChartPercentage.css('color', '#fff');
            }

            if (this.details?.invoicedToCustomerRateExcl! >= 60) {
                customerInvoicingBarChartPercentage.css('color', '#fff');
            }

            if (this.details?.subcontractorRate! >= 60) {
                subcontractorInvoicedBarChartPercentage.css('color', '#fff');
            }

            projectProgressLabourBarChart.find(barChartInnerClassName).css('height', `${this.details?.executedLabourCostRate ?? 0}%`);
            projectProgressLabourBarChart.find(percentageClassName).text(`${this.details?.executedLabourCostRate ?? 0}%`);
            projectProgressTotalBarChart.find(barChartInnerClassName).css('height', `${this.details?.executedCostRate ?? 0}%`);
            projectProgressTotalBarChart.find(percentageClassName).text(`${this.details?.executedCostRate ?? 0}%`);
            customerPaidBarChart.find(barChartInnerClassName).css('height', `${this.details?.paidInvoiceRate ?? 0}%`);
            customerPaidBarChart.find(percentageClassName).text(`${this.details?.paidInvoiceRate ?? 0}%`);
            customerInvoicingBarChart.find(barChartInnerClassName).css('height', `${this.details?.invoicedToCustomerRateExcl ?? 0}%`);
            customerInvoicingBarChart.find(percentageClassName).text(`${this.details?.invoicedToCustomerRateExcl ?? 0}%`);
            subcontractorInvoicedBarchart.find(barChartInnerClassName).css('height', `${this.details?.subcontractorRate ?? 0}%`);
            subcontractorInvoicedBarchart.find(percentageClassName).text(`${this.details?.subcontractorRate ?? 0}%`);
        }, 200);
    }

    async hide() {
        this.details = null;
        this.show = false;
    }
}
